import React from 'react';
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import TextInput from '../../../../components/UI/TextInput';
import TextArea from '../../../../components/UI/TextArea';
import Button from '../../../../components/UI/Button';
import styles from './CritiqueForm.module.scss';

interface CritiqueFormProps {
  onSubmit: (values: FormValues) => Promise<void>;
  onCancel: () => void;
  initialValues?: {
    human_scores?: number | null;
    critique?: string | null;
  };
}

interface FormValues {
  human_scores: number;
  critique: string;
}

const required = (value: any) => (value ? undefined : 'Required');

const CritiqueForm: React.FC<CritiqueFormProps> = ({ onSubmit, onCancel, initialValues }) => {
  const handleSubmit = async (values: FormValues) => {
    try {
      await onSubmit(values);
    } catch (err) {
      return { [FORM_ERROR]: err instanceof Error ? err.message : 'Failed to save critique' };
    }
  };

  return (
    <Form<FormValues>
      onSubmit={handleSubmit}
      initialValues={{
        human_scores: initialValues?.human_scores || 0,
        critique: initialValues?.critique || '',
      }}
      render={({ handleSubmit, submitting, submitError }) => (
        <form onSubmit={handleSubmit} className={styles.form}>
          <Field name="human_scores" validate={required}>
            {({ input }) => (
              <TextInput {...input} type="number" min="0" max="1" label="Human Score" fullWidth />
            )}
          </Field>
          <Field name="critique" validate={required}>
            {({ input, meta }) => (
              <TextArea
                {...input}
                label="Critique"
                required
                fullWidth
                rows={4}
                error={meta.touched && meta.error ? meta.error : undefined}
              />
            )}
          </Field>
          {submitError && <div className={styles.error}>{submitError}</div>}
          <div className={styles.actions}>
            <Button type="button" variant="ghost" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="submit" disabled={submitting} loading={submitting}>
              Save Critique
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default CritiqueForm;
